import React from 'react';
export const WPGraphQLClientContext = React.createContext(undefined);
export const useWPGraphQLClient = () => React.useContext(WPGraphQLClientContext);
